import { useContext } from "react";
import { defineMessages, IntlContext } from "react-intl";
const localized = defineMessages({
  fieldDefault: {
    id: "fieldDefault",
    defaultMessage: "Field"
  },
  fieldRequired: {
    id: "fieldRequired",
    defaultMessage: "{field} is required"
  },
  fieldShouldBeNumber: {
    id: "fieldShouldBeNumber",
    defaultMessage: "{field} should be number"
  },
  fieldShouldBeGreaterOrEqual: {
    id: "fieldShouldBeGreaterOrEqual",
    defaultMessage: "{field} should be at least {value}"
  },
  fieldShouldBeGreater: {
    id: "fieldShouldBeGreater",
    defaultMessage: "{field} should be greater than {value}"
  },
  fieldShouldBeLessOrEqual: {
    id: "fieldShouldBeLessOrEqual",
    defaultMessage: "{field} should be at most {value}"
  },
  fieldShouldBePositiveInteger: {
    id: "fieldShouldBePositiveInteger",
    defaultMessage: "{field} should be positive integer"
  },
  fieldShouldBeInteger: {
    id: "fieldShouldBeInteger",
    defaultMessage: "{field} should be integer"
  },
  fieldShouldHaveMinLength: {
    id: "fieldShouldHaveMinLength",
    defaultMessage: "{field} should be at least {value} characters"
  },
  fieldShoulHaveMaxLength: {
    id: "fieldShoulHaveMaxLength",
    defaultMessage: "{field} should be no longer than {value} characters"
  },
  fieldShouldBeEmail: {
    id: "fieldShouldBeEmail",
    defaultMessage: "Invalid email format"
  }
});
const numberRegex = /^(?:[1-9]\d*|0)?(?:\.\d+)?$/;
const twoDecimalPlacesRegex = /^\d+(\.\d{1,2})?$/;
const positiveIntegerRegex = /^\d+$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const exludeSpecialCharactersRegex = /^[^'"\\\/|()\[\]{}]*$/;
var RuleType = /* @__PURE__ */ ((RuleType2) => {
  RuleType2[RuleType2["Required"] = 0] = "Required";
  RuleType2[RuleType2["Number"] = 1] = "Number";
  RuleType2[RuleType2["PositiveInteger"] = 2] = "PositiveInteger";
  RuleType2[RuleType2["Integer"] = 3] = "Integer";
  RuleType2[RuleType2["Min"] = 4] = "Min";
  RuleType2[RuleType2["Max"] = 5] = "Max";
  RuleType2[RuleType2["MinLength"] = 6] = "MinLength";
  RuleType2[RuleType2["MaxLength"] = 7] = "MaxLength";
  RuleType2[RuleType2["GreaterThan"] = 8] = "GreaterThan";
  RuleType2[RuleType2["Email"] = 9] = "Email";
  return RuleType2;
})(RuleType || {});
const ruleMessageMapping = {
  [
    0
    /* Required */
  ]: localized.fieldRequired,
  [
    1
    /* Number */
  ]: localized.fieldShouldBeNumber,
  [
    4
    /* Min */
  ]: localized.fieldShouldBeGreaterOrEqual,
  [
    5
    /* Max */
  ]: localized.fieldShouldBeLessOrEqual,
  [
    2
    /* PositiveInteger */
  ]: localized.fieldShouldBePositiveInteger,
  [
    3
    /* Integer */
  ]: localized.fieldShouldBeInteger,
  [
    6
    /* MinLength */
  ]: localized.fieldShouldHaveMinLength,
  [
    7
    /* MaxLength */
  ]: localized.fieldShoulHaveMaxLength,
  [
    8
    /* GreaterThan */
  ]: localized.fieldShouldBeGreater,
  [
    9
    /* Email */
  ]: localized.fieldShouldBeEmail
};
const useValidationFormatter = () => {
  const { formatMessage } = useContext(IntlContext);
  return (ruleType, field, value) => {
    const ruleMessage = ruleMessageMapping[ruleType];
    const fieldNameLocalized = field ? typeof field === "string" ? field : formatMessage(field) : formatMessage(localized.fieldDefault);
    return formatMessage(ruleMessage, { field: fieldNameLocalized, value });
  };
};
const useCustomValidationFormatter = () => {
  const { formatMessage } = useContext(IntlContext);
  return (message, values) => {
    return formatMessage(message, values);
  };
};
function validateSpecialCharacters(value) {
  const regex = new RegExp(exludeSpecialCharactersRegex);
  return regex.test(value);
}
export {
  RuleType,
  emailRegex,
  exludeSpecialCharactersRegex,
  numberRegex,
  positiveIntegerRegex,
  twoDecimalPlacesRegex,
  useCustomValidationFormatter,
  useValidationFormatter,
  validateSpecialCharacters
};
//# sourceMappingURL=validation.js.map
